import React, { useState, useRef, useEffect } from 'react';
import { useIntl } from 'react-intl';

import { APP_REDE_SEGUROS_URL, APP_REDE_IZEE_URL, APP_CLIENT_ACCOUNT_URL } from '@/config';
import appsIcon from '@/images/icons/apps-menu.svg';
import grupoRv from '@/images/icons/grupo-rv.svg';
import redeIzeeIcon from '@/images/icons/izee-logo.svg';
import redeSegurosIcon from '@/images/icons/seguros-logo.svg';
import redeVistoriasIconDisabled from '@/images/icons/vistorias-logo-disabled.svg';

const ClientAppsMenu = () => {
  const [open, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const intl = useIntl();

  const handleMenuToggle = () => {
    setMenuOpen(!open);
  };

  const handleRedirectToApp = appUrl => {
    const accessToken = sessionStorage.getItem('accessToken');
    const tokenType = sessionStorage.getItem('tokenType');

    window.open(`${appUrl}#access_token=${accessToken}&token_type=${tokenType}&expires_in=`, '_blank');
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open]);

  return (
    <nav className="relative" ref={menuRef}>
      <div 
        className="cursor-pointer" 
        onClick={handleMenuToggle}
        title={intl.formatMessage({ id: 'RVGROUP_APPS_MENU_MESSAGE' })}
      >
        <img className="block h-10 w-10 ml-[18px]" src={appsIcon} alt="Apps menu" />
      </div>

      {open && (
        <div className="absolute right-0 top-full mt-5 bg-white shadow-[0_0_5px_rgba(0,0,0,0.15)] rounded-md overflow-visible z-50 py-0 min-w-[320px]">
          {/* Arrow */}
          <div className="absolute -top-[6px] right-2 w-3 h-3 bg-white border-t border-l border-white rotate-45 shadow-[-2px_-2px_2px_rgba(0,0,0,0.02)]" />
          
          <div className="block w-full mt-1 mb-[22px] pt-5 border-b border-[#d0d0d0]">
            <span className="block pb-1 pl-[22px] text-sm font-bold font-['Open_Sans'] text-[#626262]">
              Soluções Grupo RV
            </span>
          </div>

          <div className="grid grid-cols-2 gap-4 px-[22px] pb-[20px]">
            <button 
              className="bg-none border-none p-0 outline-none cursor-default opacity-50" 
              type="button" 
              disabled
            >
              <img width={130} src={redeVistoriasIconDisabled} alt="Rede Vistorias" />
            </button>
            
            <button
              className="bg-none border-none p-0 outline-none transition-transform duration-300 hover:scale-105 active:scale-95"
              type="button"
              onClick={() => handleRedirectToApp(APP_REDE_SEGUROS_URL)}
              title={intl.formatMessage({ id: 'SEGUROS_APPS_MENU_MESSAGE' })}
            >
              <img width={130} src={redeSegurosIcon} alt="Rede Seguros" />
            </button>
            
            <button 
              className="bg-none border-none p-0 outline-none transition-transform duration-300 hover:scale-105 active:scale-95" 
              type="button" 
              onClick={() => handleRedirectToApp(APP_REDE_IZEE_URL)}
              title={intl.formatMessage({ id: 'IZEE_APPS_MENU_MESSAGE' })}
            >
              <img width={130} src={redeIzeeIcon} alt="Rede Izee" />
            </button>
            
            <button
              className="bg-none border-none p-0 outline-none transition-transform duration-300 hover:scale-105 active:scale-95"
              type="button"
              onClick={() => handleRedirectToApp(APP_CLIENT_ACCOUNT_URL)}
              title={intl.formatMessage({ id: 'CLIENT_APPS_MENU_MESSAGE' })}
            >
              <img width={130} src={grupoRv} alt="Grupo RV" />
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default ClientAppsMenu;
